import { PopoverOrigin } from "@mui/material";

export const anchorOriginDefault: PopoverOrigin = {
  vertical: "bottom",
  horizontal: "right",
};

export const transformOriginDefault: PopoverOrigin = {
  vertical: "top",
  horizontal: "right",
};
